import React, { useState, useEffect, useCallback } from 'react';
import './TabCrias.css';
import API_CONFIG from '../config';
import { apiFetch } from '../auth';

const BASE = API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.ANIMALES;

export default function TabCrias({ animalId, onVerCria }) {
  const [crias, setCrias]     = useState([]);
  const [loading, setLoading] = useState(false);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiFetch(`${BASE}/${animalId}/crias`);
      setCrias(await res.json());
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [animalId]);

  useEffect(() => { cargar(); }, [cargar]);

  const formatFecha = (f) => f ? new Date(f + 'T00:00:00').toLocaleDateString('es-PY') : '-';

  const calcularEdad = (fecha) => {
    if (!fecha) return '-';
    const hoy  = new Date();
    const nac  = new Date(fecha + 'T00:00:00');
    const dias = Math.floor((hoy - nac) / (1000 * 60 * 60 * 24));
    if (dias < 30)  return `${dias}d`;
    if (dias < 365) return `${Math.floor(dias / 30)}m`;
    return `${Math.floor(dias / 365)}a ${Math.floor((dias % 365) / 30)}m`;
  };

  return (
    <div className="tab-crias">
      <div className="tab-toolbar">
        <h3>🐮 Crías</h3>
        <span className="crias-count">{crias.length} cría(s) registrada(s)</span>
      </div>

      {loading ? (
        <div className="loading">Cargando crías...</div>
      ) : crias.length === 0 ? (
        <div className="empty-state">
          <p>🐮 Este animal no tiene crías registradas.</p>
          <small>Las crías se registran creando un nuevo animal e indicando el ID de esta madre.</small>
        </div>
      ) : (
        <div className="crias-grid">
          {crias.map(c => (
            <div key={c.id} className="cria-card" onClick={() => onVerCria && onVerCria(c.id)}>
              <div className="cria-caravana">
                <span className={`badge badge-${c.sexo?.toLowerCase()}`}>
                  {c.sexo === 'MACHO' ? '♂' : '♀'}
                </span>
                <strong>{c.caravana}</strong>
              </div>
              {c.nombre && <div className="cria-nombre">{c.nombre}</div>}
              <div className="cria-info">
                {c.raza && <span>🧬 {c.raza}</span>}
                {c.fechaNacimiento && (
                  <span>📅 {formatFecha(c.fechaNacimiento)} ({calcularEdad(c.fechaNacimiento)})</span>
                )}
              </div>
              <div className="cria-footer">
                <span className={`badge badge-${c.estado?.toLowerCase()}`}>{c.estado}</span>
                <span className="ver-ficha">Ver ficha →</span>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="crias-ayuda">
        <p>💡 Para agregar una cría, registrá el animal nuevo y asigná esta madre en su ficha.</p>
      </div>
    </div>
  );
}
